import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/closing-notes'),
      component: () => import('../Wrapper'),
      props: {
        headerTitle: 'SIDEBAR.CLOSING_NOTES',
        icon: 'file',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'notes_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'notes_list',
          roles: ['administrator'],
          component: () => import('./Index'),
          meta: {
            permission: 'show_closing_notes',
          },
        },
      ],
    },
  ],
};
